<template>
    <div class="layout-footer">
        <div
            v-for="item in menus"
            :key="item.path"
            :class="{
                active: item.path === $route.meta.name,
                'has-on': item.path === $route.meta.name && item.iconOn,
            }"
            @click="handleClick(item)"
        >
            <div class="icon-box">
                <img :src="item.path === $route.meta.name && item.iconOn ? item.iconOn : item.icon" alt="">
            </div>
            <span>{{ item.title }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'layout-footer',
    computed: {
        menus() {
            return [
                {
                    icon: require('../assets/img/layout/tab-home.png'),
                    iconOn: require('../assets/img/layout/tab-home-on.png'),
                    title: this.$t('menu.home'),
                    path: 'home',
                },
                {
                    icon: require('../assets/img/layout/tab-exchange.svg'),
                    title: this.$t('menu.exchange'),
                    path: 'exchange',
                },
                {
                    icon: require('../assets/img/layout/tab-mine.png'),
                    iconOn: require('../assets/img/layout/tab-mine-on.png'),
                    title: this.$t('menu.mining'),
                    path: 'mining',
                },
                {
                    icon: require('../assets/img/layout/tab-earn.png'),
                    title: this.$t('menu.assets'),
                    path: 'earnings',
                },
                {
                    icon: require('../assets/img/layout/tab-me.png'),
                    title: this.$t('menu.me'),
                    path: 'me',
                },
            ]
        }
    },
    methods: {
        handleClick(item) {
            if (!item.path) return;
            this.$router.push({ name: item.path })
        }
    },
}
</script>

<style lang="less">
.layout-footer {
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: 16px;
    z-index: 30;
    width: auto;
    height: 60px;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border-radius: 30px;
    box-shadow: 0 8px 24px rgba(16, 17, 38, 0.08);

    > div {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .icon-box {
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
        }

        img {
            width: 24px;
            height: 24px;
            opacity: 0.4;
        }

        span {
            margin-top: 2px;
            font-size: 10px;
            line-height: 14px;
            color: #101126;
            opacity: 0.5;
        }

        &.active {
            span {
                color: #101126;
                opacity: 1;
            }

            img {
                opacity: 1;
            }

            &:not(.has-on) .icon-box {
                background-image: linear-gradient(180deg, #FEF81B 0%, #FFB906 100%);
            }
        }
    }
}
</style>
